<template>
  <app-side-menu :min-width="18"
    :fixed-menu="false">
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          {{ vendorName }}
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <router-link :to="{ name: routeTypes.PaymentEntryDetail.name, params: { invoiceId : $route.params.vendorId }, query: $route.query }"
            active-class="is-active"
            exact>
            <span>
              Invoices
            </span>
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import PaymentEntryRoutes from './route-types'

export default {
  name: 'PaymentEntrySideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu
  },
  props: {
    vendorName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    routeTypes() {
      return PaymentEntryRoutes
    }
  },
  mounted() {},
  methods: {}
}
</script>
